/*
 * @Author: 李朋飞
 * @Date: 2021-12-09 14:39:27
 * @LastEditTime: 2021-12-09 14:39:28
 * @Description: 
 */
import Steps from './Steps.vue';

export default {
  install(Vue) {
    Vue.component('Steps', Steps);
  }
};


// WEBPACK FOOTER //
// ./src/components/Steps/index.js